const theme = {
  "_": {
    "900": "#1C2D55",
    "800": "#263B72",
    "700": "#2F4A8E",
    "600": "#3959AA",
    "500": "#4669c1",
    "400": "#627FCB",
    "300": "#7C95D3"
  },
  "primary": {
    "900": "#432B69",
    "800": "#4F327B",
    "700": "#5B398D",
    "600": "#66419F",
    "500": "#7248B1",
    "400": "#7F58BB",
    "300": "#8D6AC2"
  }
}

export default theme